import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

export default function AdminGate({ children }: { children: React.ReactNode }) {
  const { loading, session, isAdmin } = useAuth();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-[#fbf9f4] text-slate-600">Loading…</div>;
  }
  if (!session) return <Navigate to="/admin/login" replace />;
  if (!isAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#fbf9f4] p-6 text-center">
        <div>
          <h1 className="font-serif text-2xl text-slate-900 mb-2">Not authorized</h1>
          <p className="text-slate-600">Your account is signed in but does not have admin role.</p>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
